import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";

export default function Editar(props) {
  const [listaCiclos, setListaCiclos] = useState([]);
  const [cicloSelecionado, setCicloSelecionado] = useState(false);
  const [profId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [dadosCiclos, setDadosCiclos] = useState({});
  const [ciclos, setCiclos] = useState([]);
  const [profissional, setProfissional] = useState({});
  const [usuario, setUsuario] = useState({});
  const [comboEscolas, setComboEscolas] = useState([]);
  const [comboFuncoes, setComboFuncoes] = useState([]);

  useEffect(() => {
    carregarProfissionais();
    listarCiclos();
    carregarComboEscolas();
    carregarFuncoes();
  }, []);

  const carregarProfissionais = () => {
    setCarregando(true);
    api
      .get("profissionais/carregar", { id: profId })
      .then((profissional) => {
        const usuario = {
          id: profissional.usuarioId,
          nome: profissional.usuarioNome,
          CPF: profissional.usuarioCPF,
          email: profissional.usuarioEmail,
          telefone: profissional.usuarioTelefone
        };

        setUsuario(usuario);
        setProfissional(profissional);

        setCarregando(false);
        carregarCiclo(profissional.escolaId);
      })
      .catch((err) => {
        setCarregando(false);

        notification("error", "Não localizado");
      });
  };

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarFuncoes = () => {
    api.get("funcoes/listar").then((res) => {
      setComboFuncoes(res);
    });
  };

  const carregarCiclo = (escolaId) => {
    api.get("escolas/listarCiclos", { escolaId }).then((res) => {
      setCiclos(res);
    });
  };

  const listarCiclos = () => {
    api
      .get("profissionais/listarCiclos", { profissionalId: profId })
      .then((res) => {
        setListaCiclos(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar filhos");
      });
  };

  const abrirCiclo = (registro) => {
    setCicloSelecionado(true);
    setDadosCiclos(registro);
  };

  const tRegistros = {
    onLineClick: abrirCiclo,
    newItemAction: () => setCicloSelecionado(true),
    title: "Ciclos adquiridos",
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
    ],
    array: listaCiclos,
  };

  const salvarCiclo = (params) => {
    const vinculo = params;
    vinculo.profissionalId = profId;

    api
      .post("profissionais/vincularCiclo", vinculo)
      .then((res) => {
        notification("success", "Ciclo vinculado");
        setCicloSelecionado(false);
        setDadosCiclos({});
        listarCiclos();
      })
      .catch((err) => notification("error", "Erro ao salvar o ciclo"));
  };

  const removerCiclo = () => {
    const vinculo = {
      profissionalId: profId,
      cicloId: dadosCiclos.id,
    };

    api
      .post("profissionais/desvincularCiclo", vinculo)
      .then((res) => {
        notification("success", "Desvinculado com sucesso.");
        setCicloSelecionado(false);
        setDadosCiclos({});
        listarCiclos();
      })
      .catch((err) => notification("error", "Erro ao salvar o ciclo"));
  };

  const camposfiltrosCiclos = () => {
    const campos = {
      cicloId: !dadosCiclos.id
        ? {
            label: "Ciclo",
            type: "select",
            array: {
              data: ciclos,
              value: "cicloId",
              desc: "cicloNome",
            },
            emptyItem: true,
            emptyText: "(Selecione)",
            value: dadosCiclos.id,
          }
        : {
            label: "ciclo",
            type: "text",
            readOnly: true,
            value: dadosCiclos.nome,
          },
    };

    return campos;
  };

  const fCiclos = {
    title: "Ciclo",
    form: camposfiltrosCiclos(),

    submit: !dadosCiclos.id
      ? {
          label: "Salvar",
          action: salvarCiclo,
        }
      : undefined,

    close: {
      label: "Fechar",
      action: () => {
        setCicloSelecionado(false);
        setDadosCiclos({});
      },
    },

    customActions: dadosCiclos.id
      ? [
          {
            label: "Remover",
            action: () => removerCiclo(),
          },
        ]
      : undefined,
  };

  const salvarDados = (form) => {
    form.id = usuario.id;

    setUsuario(form);
    api
      .post("usuarios/editar", form)
      .then((res) => {
        notification("success", "Dados cadastrais editado com sucesso!");
        carregarProfissionais();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "CPF inválido");
          case 3:
            return notification("error", "Email inválido");
          case 4:
            return notification("error", "CPF já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Dados cadastrais",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: usuario.nome,
        space: 6,
      },
      CPF: {
        label: "CPF",
        type: "number",
        value: usuario.CPF,
        space: 6,
      },
      email: {
        label: "Email",
        type: "text",
        value: usuario.email,
        space: 6
      },
      telefone: {
        label: "Telefone",
        type: "text",
        value: usuario.telefone,
        space: 6
      },
    },
    submit: {
      label: "Salvar",
      action: salvarDados,
    },
  };

  const salvarProf = (form) => {
    form.id = profissional.id;

    setProfissional(form);

    api
      .post("profissionais/editar", form)
      .then((res) => {
        notification("success", "Dados profissionais editado com sucesso!");
        carregarProfissionais();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Escola inválida");
          case 2:
            return notification("error", "Função inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fProf = {
    title: "Dados do profissional",
    form: {
      funcaoId: {
        label: "Função",
        type: "select",
        emptyItem: true,
        space: 5,
        array: {
          data: comboFuncoes,
          value: "id",
          desc: "nome",
        },
        value: profissional.funcaoId,
      },
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 5,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: profissional.escolaId,
      },
      acessoLiberado: {
        label: "Ativo (acesso liberado)",
        type: "check",
        space: 2,
        value: profissional.acessoLiberado,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarProf,
    },
  };

  return (
    <>
      {!cicloSelecionado ? (
        <>
          {carregando ? (
            <CircularProgress />
          ) : (
            <>
              <Form formData={fDados} />
              <br />
              <Form formData={fProf} />
              <br />
              <ActionTable structure={tRegistros} />
            </>
          )}
        </>
      ) : (
        <Form formData={fCiclos} />
      )}
    </>
  );
}
